import React, { useCallback, useEffect, useState } from 'react'
import {
    Button,
    Card,
    CardContent,
    Container,
    Grid,
    Paper,
    TextField,
    Typography,
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Layout from '../Layout'
import Header from '../form/Header'
import AppForm from '../form/AppForm'
import AppSelectNameId from '../form/AppSelectNameId'
import ItemSelect from '../form/ItemSelect'
import {
    getAllDefectiveItemSuppliers,
    getSearchItems,
} from '../../store/actions/defectiveItemAction'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import { addNewDefectiveGroup } from '../../store/actions/defectiveGroupAction'

const ItemList = ({ defectiveItem, handleDeleteItem }) => (
    <TableRow>
        <TableCell>{defectiveItem.itemSKU}</TableCell>
        <TableCell>
            {defectiveItem.defectiveType === 1 ? '+' : '-'}
            {defectiveItem.quantity}
        </TableCell>
        <TableCell>{defectiveItem.note}</TableCell>
        <TableCell style={{ width: '50px' }}>
            <Button
                onClick={() => handleDeleteItem(defectiveItem.id)}
                size="small"
                color="error"
                variant="outlined"
            >
                Delete
            </Button>
        </TableCell>
    </TableRow>
)

const DefectiveGroupForm = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { searchItems, suppliers } = useSelector(
        (state) => state.defectiveItem
    )
    const [increaseItemId, setIncreaseItemId] = useState(null)
    const [decreaseItemId, setDecreaseItemId] = useState(null)
    const [itemStock, setItemStock] = useState(0)
    const [increaseItemOption, setIncreaseItemOption] = useState(null)
    const [decreaseItemOption, setDecreaseItemOption] = useState(null)
    const [increaseItems, setIncreaseItems] = useState([])
    const [decreaseItems, setDecreaseItems] = useState([])
    const [groupName, setGroupName] = useState('')
    const [note, setNote] = useState('')

    useEffect(() => {
        dispatch(getAllDefectiveItemSuppliers())
    }, [dispatch])

    const validationIncreaseSchema = Yup.object().shape({
        quantity: Yup.number().required().label('Quantity'),
    })

    const validationDecreaseSchema = Yup.object().shape({
        quantity: Yup.number()
            .required()
            .label('Quantity')
            .test('must less stock', 'quantity over stock', function (value) {
                return value <= itemStock
            }),
    })

    const handleIncreaseSearchItemChange = (option) => {
        if (option) {
            // const [, stock] = option.label.split('|')
            setIncreaseItemId(option.value)
            // setItemStock(stock)
            setIncreaseItemOption(option)
        }
    }

    const handleDecreaseSearchItemChange = (option) => {
        if (option) {
            const [, stock] = option.label.split('|')
            setDecreaseItemId(option.value)
            setItemStock(stock)
            setDecreaseItemOption(option)
        }
    }

    const handleInputChange = (inputValue) => {
        const values = { search: inputValue }
        dispatch(getSearchItems(values))
    }

    const handleSubmit = useCallback(() => {
        if (!groupName) {
            alert('Group Name empty')
            return
        }
        const defectiveItems = [...increaseItems, ...decreaseItems]
        if (defectiveItems.length === 0) {
            alert('Item empty')
            return
        }
        const values = {
            groupName,
            note,
            defectiveItems,
        }
        console.log('values ==>', values)

        dispatch(addNewDefectiveGroup(values, navigate))
    }, [dispatch, groupName, increaseItems, decreaseItems, note, navigate])

    const handleDeleteIncreaseItem = useCallback((id) => {
        setIncreaseItems((pre) => pre.filter((item) => item.id !== id))
    }, [])

    const handleDeleteDecreaseItem = useCallback((id) => {
        setDecreaseItems((pre) => pre.filter((item) => item.id !== id))
    }, [])

    return (
        <Layout>
            <Container>
                <div className="order-products-box">
                    <Button
                        variant="outlined"
                        color="success"
                        onClick={() => navigate(-1)}
                        style={{ marginBottom: '10px' }}
                    >
                        Back
                    </Button>
                    <Header title="Add Defective Group" />
                    <TextField
                        fullWidth
                        name="groupName"
                        label="Group Name"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        style={{ marginBottom: '20px' }}
                    />
                    <TextField
                        fullWidth
                        name="note"
                        label="Note"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        style={{ marginBottom: '20px' }}
                    />
                    <Card style={{ minHeight: '400px', marginBottom: '30px' }}>
                        <CardContent sx={{ height: '100%' }}>
                            <Typography variant="h5" component="div">
                                Increase
                            </Typography>

                            <AppForm
                                initialValues={{
                                    quantity: '',
                                    supplierIdIncrease: suppliers?.[0]?.id,
                                    note: '',
                                }}
                                onSubmit={(values, { resetForm }) => {
                                    const [itemSKU] =
                                        increaseItemOption.label.split('|')
                                    const submitValues = {
                                        supplierId: values.supplierIdIncrease,
                                        note: values.note,
                                        itemId: increaseItemId,
                                        quantity: values.quantity,
                                        itemSKU,
                                        defectiveType: 1,
                                        id: increaseItems.length + 1,
                                    }
                                    setIncreaseItems((pre) => [
                                        ...pre,
                                        submitValues,
                                    ])
                                    setIncreaseItemOption(null)
                                    setIncreaseItemId(null)
                                    setItemStock(0)
                                    resetForm()
                                }}
                                validationSchema={validationIncreaseSchema}
                            >
                                <AppSelectNameId
                                    name="supplierIdIncrease"
                                    label="Supplier"
                                    options={suppliers}
                                />

                                <ItemSelect
                                    name="itemOption"
                                    value={increaseItemOption}
                                    onChange={handleIncreaseSearchItemChange}
                                    onInputChange={handleInputChange}
                                    options={searchItems}
                                    placeholder="Defective Item"
                                />
                                {increaseItemId && (
                                    <Grid
                                        container
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                        }}
                                        gap={2}
                                    >
                                        <Grid item xs={3}>
                                            <AppInput
                                                name="quantity"
                                                size="small"
                                                variant="outlined"
                                                label={`Quantity`}
                                                type="number"
                                                required={true}
                                                inputProps={{
                                                    maxLength: 10,
                                                }}
                                                style={{
                                                    marginTop: '10px',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <AppInput
                                                name="note"
                                                size="small"
                                                variant="outlined"
                                                label={`Note`}
                                                type="text"
                                                style={{
                                                    marginTop: '10px',
                                                }}
                                                inputProps={{
                                                    maxLength: 200,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <SubmitButton
                                                variant="outlined"
                                                title="Add"
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            </AppForm>

                            {increaseItems?.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>
                                                            Item SKU
                                                        </TableCell>
                                                        <TableCell>
                                                            Quantity
                                                        </TableCell>
                                                        <TableCell>
                                                            Note
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                width: '50px',
                                                            }}
                                                        ></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {increaseItems.map(
                                                        (defectiveItem) => (
                                                            <ItemList
                                                                defectiveItem={
                                                                    defectiveItem
                                                                }
                                                                key={
                                                                    defectiveItem.id
                                                                }
                                                                handleDeleteItem={
                                                                    handleDeleteIncreaseItem
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            )}
                        </CardContent>
                    </Card>

                    <Card style={{ minHeight: '400px', marginBottom: '30px' }}>
                        <CardContent sx={{ height: '100%' }}>
                            <Typography variant="h5" component="div">
                                Decrease
                            </Typography>

                            <AppForm
                                initialValues={{
                                    quantity: '',
                                    supplierId: suppliers?.[0]?.id,
                                    note: '',
                                }}
                                onSubmit={(values, { resetForm }) => {
                                    const [itemSKU] =
                                        decreaseItemOption.label.split('|')
                                    const submitValues = {
                                        ...values,
                                        itemId: decreaseItemId,
                                        itemSKU,
                                        defectiveType: 2,
                                        id: decreaseItems.length + 1,
                                    }
                                    setDecreaseItems((pre) => [
                                        ...pre,
                                        submitValues,
                                    ])
                                    setDecreaseItemOption(null)
                                    setDecreaseItemId(null)
                                    setItemStock(0)
                                    resetForm()
                                }}
                                validationSchema={validationDecreaseSchema}
                            >
                                <AppSelectNameId
                                    name="supplierId"
                                    label="Supplier"
                                    options={suppliers}
                                />
                                <ItemSelect
                                    name="itemOption"
                                    value={decreaseItemOption}
                                    onChange={handleDecreaseSearchItemChange}
                                    onInputChange={handleInputChange}
                                    options={searchItems}
                                    placeholder="Defective Item"
                                />
                                {decreaseItemId && (
                                    <Grid
                                        container
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                        }}
                                        gap={2}
                                    >
                                        <Grid item xs={3}>
                                            <AppInput
                                                name="quantity"
                                                size="small"
                                                variant="outlined"
                                                label={`Quantity`}
                                                type="number"
                                                required={true}
                                                inputProps={{
                                                    maxLength: 10,
                                                }}
                                                style={{
                                                    marginTop: '10px',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <AppInput
                                                name="note"
                                                size="small"
                                                variant="outlined"
                                                label={`Note`}
                                                type="text"
                                                style={{
                                                    marginTop: '10px',
                                                }}
                                                inputProps={{
                                                    maxLength: 200,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <SubmitButton
                                                variant="outlined"
                                                title="Add"
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            </AppForm>

                            {decreaseItems?.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>
                                                            Item SKU
                                                        </TableCell>
                                                        <TableCell>
                                                            Quantity
                                                        </TableCell>
                                                        <TableCell>
                                                            Note
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                width: '50px',
                                                            }}
                                                        ></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {decreaseItems.map(
                                                        (defectiveItem) => (
                                                            <ItemList
                                                                defectiveItem={
                                                                    defectiveItem
                                                                }
                                                                key={
                                                                    defectiveItem.id
                                                                }
                                                                handleDeleteItem={
                                                                    handleDeleteDecreaseItem
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            )}
                        </CardContent>
                    </Card>
                    {groupName && (
                        <div style={{ marginTop: '20px' }}>
                            <Button
                                color="info"
                                variant="contained"
                                fullWidth
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </div>
                    )}
                </div>
            </Container>
        </Layout>
    )
}

export default DefectiveGroupForm
